import axios from "axios";

import {
  getAdminProfileService,
  updateProfileService,
} from "../../../Services/AuthService";
import {
  fetchProfileFailure,
  fetchProfileStart,
  fetchProfileSuccess,
  updateProfileFailure,
  updateProfileStart,
  updateProfileSuccess,
} from "./reducer";
import { toast } from "react-toastify";

//thunk to get the admin profile
export const getAdminProfile = (id) => async (dispatch) => {
  try {
    dispatch(fetchProfileStart());

    const response = await getAdminProfileService(id);

    dispatch(fetchProfileSuccess(response.data));
  } catch (error) {
    dispatch(fetchProfileFailure(error));
  }
};

//thunk to update the profile
export const updateAdminProfile = (payload, formData) => async (dispatch) => {
  dispatch(updateProfileStart());
  try {
    const response = await updateProfileService(formData, payload);

    if (response.success) {
      toast.success(response.message);
      dispatch(updateProfileSuccess(response.data));
    } else {
      dispatch(updateProfileFailure(response.message));
    }
  } catch (error) {
    dispatch(updateProfileFailure(error.message));
  }
};
